import { computed, unref, type MaybeRef } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { session } from '@/composables/useSession'
import { getAssignments } from '@/modules/tasks/api'
import { tasksAssignmentKeys } from './keys'

interface UseAssignmentsQueryOptions {
  enabled?: MaybeRef<boolean>
}

export const useAssignmentsQuery = (options: UseAssignmentsQueryOptions = {}) => {
  const workspaceId = computed(() => session.workspace?.id ?? null)
  const enabled = computed(() => workspaceId.value !== null && unref(options.enabled ?? true))

  return useQuery({
    queryKey: computed(() => tasksAssignmentKeys.list(workspaceId.value)),
    queryFn: () => getAssignments(),
    enabled,
    retry: false,
  })
}
